// extracted by mini-css-extract-plugin
module.exports =  {"contactsWrapper":"Skeleton-Skeleton-contactsWrapper-ecda6c58","profileImage":"Skeleton-Skeleton-profileImage-abd98631","profileInfo":"Skeleton-Skeleton-profileInfo-b0d5219e"};